import { useMemo } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  ArcElement,
  Tooltip,
  Legend,
  Title,
} from "chart.js";
import { Bar, Pie } from "react-chartjs-2";
import "./AssignmentProblemsPieChart.css";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  ArcElement,
  Tooltip,
  Legend,
  Title
);

const PIE_COLORS = [
  "#3b82f6", "#f59e0b", "#10b981", "#ef4444", "#8b5cf6",
  "#ec4899", "#14b8a6", "#f97316", "#6366f1", "#84cc16",
];

export default function AssignmentProblemsBarChart({ submissions }) {
  const distribution = useMemo(() => {
    if (!submissions || submissions.length === 0) return null;

    const maxSolved = Math.max(...submissions.map((s) => s.problemsSolved || 0), 0);
    const dist = {};
    for (let i = 0; i <= maxSolved; i++) dist[i] = 0;
    submissions.forEach((s) => { dist[s.problemsSolved || 0]++; });
    return dist;
  }, [submissions]);

  if (!distribution) return <p className="no-data">No data available</p>;

  const labels = Object.keys(distribution).map((v) => `${v} Solved`);
  const values = Object.values(distribution);

  const barData = {
    labels,
    datasets: [{
      label: "Students",
      data: values,
      backgroundColor: "#3b82f6",
      borderColor: "#3b82f6",
      borderWidth: 1,
      borderRadius: 0,
      maxBarThickness: 55,
    }],
  };

  const pieData = {
    labels,
    datasets: [{
      data: values,
      backgroundColor: labels.map((_, i) => PIE_COLORS[i % PIE_COLORS.length]),
      borderColor: "#fff",
      borderWidth: 2,
    }],
  };

  const barOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      title: {
        display: true,
        text: "Problems Solved Distribution (Bar)",
        font: { size: 18, weight: "bold" },
      },
      legend: { display: true, position: "top" },
      tooltip: { callbacks: { label: (ctx) => `${ctx.raw} Students` } },
    },
    scales: {
      x: { ticks: { font: { size: 13 } } },
      y: { beginAtZero: true, ticks: { stepSize: 1, font: { size: 13 } } },
    },
  };

  const pieOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      title: {
        display: true,
        text: "Problems Solved Distribution (Pie)",
        font: { size: 18, weight: "bold" },
      },
      legend: { display: true, position: "bottom" },
      tooltip: { callbacks: { label: (ctx) => `${ctx.label}: ${ctx.raw} Students` } },
    },
  };

  return (
    <div className="charts-row">
      <div className="pie-card">
        <div className="pie-chart-container">
          <Pie data={pieData} options={pieOptions} />
        </div>
      </div>
      <div className="pie-card">
        <div className="pie-chart-container">
          <Bar data={barData} options={barOptions} />
        </div>
      </div>
    </div>
  );

}